export function OutlineCotizadorUrbanosIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9992 18.0018H7.7284C7.37797 17.4018 6.73951 16.9986 6.00025 16.9986C5.26099 16.9986 4.61774 17.4018 4.26731 18.0018H3V10.998H14.9962"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00183 18.9989C8.00183 20.0982 7.10415 21.0007 6.00006 21.0007C4.89597 21.0007 3.99829 20.0982 3.99829 18.9989C3.99829 18.6389 4.0991 18.2885 4.26711 18.0004C4.61754 17.4004 5.256 17.002 5.99526 17.002C6.73452 17.002 7.37778 17.4004 7.7234 18.0004C7.89142 18.2885 7.99223 18.6389 7.99223 18.9989H8.00183Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M15.001 11.0023H3V5.00657C3 3.89768 3.89768 3 5.00657 3H21.0063V10.0038"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0009 3L14.9961 11.0023"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00049 3V11.0023"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.002H4.93936"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0011 14.5014C20.5787 14.199 19.6906 13.6565 18.5001 13.6661C18.0057 13.6661 16.7864 13.6805 16.3015 14.5014C16.0423 14.943 15.9799 15.6439 16.3015 16.1672C17.1416 17.5401 19.8586 16.4648 20.6987 17.8329C21.0155 18.3513 20.9627 19.057 20.6987 19.4986C20.2331 20.2907 19.081 20.3195 18.5769 20.3339C17.3624 20.3627 16.4359 19.8107 16.0039 19.4986"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M18.5002 12V13.6657" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M18.5002 20.334V21.9997" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
